<div class="rounded-4xl shadow-lg/30 w-full flex overflow-hidden">
  <div class="bg-(--color-card-bg-header) w-5"></div>
  <div class="flex flex-col gap-2 p-3 w-[calc(100%-1.25rem)]">
    <div class="flex justify-between w-full">
      <div class="flex items-center gap-2 text-(--color-card-header)!">
        <mat-icon class="text(--color-card-header-icon)!">add_location</mat-icon>
        <!-- <div class="font-light">{{ itemLocation?.title }}</div> -->
        <div class="font-semibold">{{ itemLocation?.id }}</div>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <div class="grid gap-2 grid-cols-2">
        @for (data of itemLocation?.dataGrid; track data) {
          <div class="flex flex-col gap-2 text-sm text-(--color-text-primary)">
            <div class="font-semibold">{{ data.description }}</div>
            <div class="font-medium">
              {{ data.value }}
            </div>
          </div>
        }
      </div>

      <div class="flex flex-col gap-2">
        @for (data of itemLocation?.dataColum; track data) {
          <div class="flex flex-col gap-2 text-sm">
            <div class="text-(--color-text-primary) font-medium">
              <samp class="font-semibold">{{ data.description }}</samp>
              {{ data.value }}
            </div>
          </div>
        }
      </div>

      <div class="flex justify-end gap-2 px-1">
        @if (itemLocation?.textButton) {
          <button
            class="button-general-border px-2! w-[50%]"
            matButton
            type="submit"
            (click)="onEventDetail()"
          >
            {{ itemLocation?.textButton }}
          </button>
        }
        @for (button of itemLocation?.buttons; track button) {
          @if (button.type != '') {
            <button
              matMiniFab
              class="text-lg bg-transparent! shadow-none!"
              (click)="onEvent(button)"
            >
              <mat-icon class="text-3xl! size-7.5! text-(--color-card-icon)!">{{
                button.icon
              }}</mat-icon>
            </button>
          } @else {
            <div class="size-12"></div>
          }
        }
      </div>
    </div>
  </div>
</div>
